<template>
    <div class="bg-white rounded box-shadow p-3 mb-1" style="padding-bottom:1px !important">
        <div class="row">
            <div v-if="show" class="alert alert-danger alert-dismissible fade show" role="alert">
                <span v-for="(err, index) in validation_errors" :key="index">
                  {{ err[0] }} <br />
                </span>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h5 class="float-left">8. Structure (Residence/Business) Rent Related (Only Affected):</h5>
            </div>
            <div class="col">
                <b-button v-b-modal.structure-rent-modal type="button"
                          @click="resetForm(),$bvModal.show('structure-rent-modal')"
                          class="btn btn-success float-right btn-sm mb-1 text-black float-right">
                    Add Structure Rent
                    <i class="fas fa-plus"></i>
                </b-button>
            </div>
        </div>

        <div class="scrollable-table">
            <table class="table table-centered table-striped" style="overflow-x: auto">
                <thead>
                <tr>
                    <th>SL</th>
                    <th>Structure</th>
                    <th>Name of Tenant</th>
                    <th>Father's Name</th>
                    <th>Present Address</th>
                    <th>Monthly Rent</th>
                    <th># of HH Member</th>
                    <th>Received as Advanced (Tk.)</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(structure_rent, index) in structure_rents" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>Mouza: {{ structure_rent.structure.land.mouza.mouza_desc }}, Plot: {{ structure_rent.structure.land.plot_no }}</td>
                    <td>{{ structure_rent.ses.name }}</td>
                    <td>{{ structure_rent.ses.father_husband_name }}</td>
                    <td>{{ structure_rent.address }}</td>
                    <td>{{ structure_rent.rent_monthly }}</td>
                    <td>{{ structure_rent.member_household }}</td>
                    <td>{{ structure_rent.amount_advance }}</td>
                    <td>
                        <b-button v-if="(structure_rent.structure.payment_structure == null)"  variant="warning"
                                  class="btn btn-warning btn-xs waves-effect waves-light  mr-2"
                                  @click.prevent="getStructureRent(structure_rent), $bvModal.show('structure-rent-modal')">
                            <i class="far fa-edit"></i></b-button>
                        <b-button v-if="(structure_rent.structure.payment_structure == null)"  variant="danger"
                                  class="btn btn-warning btn-xs waves-effect waves-light"
                                  @click.prevent="softDelete(structure_rent.id)"><i
                                class="far fa-trash-alt"></i></b-button>
                    </td>
                </tr>
                </tbody>
            </table>
          <div v-if="loader" class="loader">Loading...</div>
            <h5 v-if="structure_rents.length === 0" class="text-center text-secondary">
                No Data Found
            </h5>
        </div>

        <structure-rent-modal
                :structure_rent="structure_rent"
                :btn_edit="btn_edit"
                @getPersonStructureRent="getPersonStructureRent"
                @resetForm="resetForm"
        ></structure-rent-modal>
    </div>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import StructureRentModal from "../../modals/StructureRentModal";

    export default {
        page: {
            title: "Search Structure Rent",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, StructureRentModal},
        data() {
            return {
                title: "Search Structure Rent",
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Search',
                        active: true,
                    },
                ],
                structure_rents: {},
                structure_rent: {
                    father_hus_type: 'F',
                    id_type: 'N'
                },

                btn_edit: false,
                validation_errors: {},
                show: false,
                loader: false
            };
        },

        mounted() {
            this.getPersonStructureRent();
            this.structure_rent.ses_id = this.$route.params.ses_id;
        },

        methods: {
            async getStructureRent(structure_rent) {
                this.structure_rent = {};
                this.btn_edit = true;
                await http.get("api/structure-rents/" + structure_rent.id + "/edit").then(response => {
                    if (!response.error) {
                        this.structure_rent = response.data.structure_rent;
                    }
                });
            },
            softDelete(structure_rent_id) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/structure-rents/" + structure_rent_id).then(response => {
                        if (!response.error) {
                            this.$bvToast.toast(response.data.message, {
                                title: "Success",
                                autoHideDelay: 5000,
                                variant: "success"
                            });
                            this.getPersonStructureRent();
                        } else {
                            this.$bvToast.toast("Deleted Failed", {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        }
                    });
                }
            },
            async getPersonStructureRent() {
                this.loader = true
                let ses_id = this.$route.params.ses_id;
                await http.get("api/structure-rent/getPersonStructureRent/" + ses_id)
                    .then(response => {
                        if (!response.error) {
                            this.loader = false
                            this.structure_rents = response.data.structure_rents;
                        }
                    });
            },
            resetForm() {
                this.$children[0].getCodes()
                this.btn_edit = false;
                this.structure_rent = {};
                this.structure_rent.ses_id = this.$route.params.ses_id;
              //  this.structure_rent.is_inc_pay = 1;
                this.structure_rent.structure_id = "";
                this.structure_rent.business_id = "";
                this.structure_rent.gender_id = "";
                this.structure_rent.id_type = "N"
            },
        },
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    .custom-select {
        -webkit-appearance: unset;
    }
    .vdp-datepicker input {
        width: 100%;
        border-radius: 3px;
        border: 1px solid #ced4da;
        height: 30px;
        padding-left: 15px;
        color: #6b757d;
    }
    .multiselect__tags {
        border-color: #ced4da;
        border-radius: 3px;
        min-height: 30px;
        padding: 4px 25px 0px 10px;
        margin-bottom: 0;
    }
    .multiselect__tag {
        margin-bottom: 0px;
    }
    .multiselect__placeholder {
        margin-bottom: 0px;
    }
    .multiselect__select {
        height: 30px;
    }
    .custom-select {
        color: #6c757d !important;
    }
</style>
